import { isMobile } from './isMobile';
import { gameMainDrawer } from '../game/drawers/gameMainDrawer';

const maxHeight = 1280;
const maxWidth = 720;
const target = document.querySelector('.root');
const mozillaTarget = document.querySelector('.root');

export const resizeGame = (canvas) => {
  const portrait = window.matchMedia('(orientation: portrait)').matches;
  if (portrait) {
    const container = canvas.parentElement;
    const { clientWidth: parentWidth, clientHeight: parentHeight } = container;
    const scaleFactor = Math.min(parentWidth / 540, parentHeight / 960);
    const w = Math.round(540 * scaleFactor),
      h = Math.round(960 * scaleFactor);
    canvas.style.width = `${w}px`;
    canvas.style.height = `${h}px`;
  }

  // const { width } = window.screen;
  // const { height } = window.screen;
  // const windowHeight = window.innerHeight;
  // const canvasHeight = canvas.offsetHeight;
  // gameMainDrawer.pixiApplication.stage.scale = {
  //   x: Math.min(width / 540, height / 960),
  //   y: Math.min(width / 540, height / 960),
  // };
  //
  // if (windowHeight < canvasHeight) {
  //   gameMainDrawer.pixiApplication.stage.scale = {
  //     x: Math.min(window.innerWidth / 540, windowHeight / 960),
  //     y: Math.min(window.innerWidth / 540, windowHeight / 960),
  //   };
  //   gameMainDrawer.pixiApplication.stage.position.set(0);
  // }
};
export const resizeGameHandler = () => {
  const canvas = document.querySelector('canvas');
  if (canvas?.style) {
    if (isMobile()) {
      // eslint-disable-next-line no-restricted-globals
      // console.log(canvas.clientWidth > canvas.clientHeight ? 'porte' : 'land');
      const scale = resizeGame(canvas);
      // gameMainDrawer.scalePixiAppStage(scale);
      return;
    }
    const maxWidth = isMobile() ? 540 : 1440;
    const maxHeight = isMobile() ? 960 : 810;
    const wWidth = window.innerWidth;
    const wHeight = window.innerHeight;
    const wWidthToHeight = wWidth / wHeight;
    const widthToHeight = maxWidth / maxHeight;

    if (wWidthToHeight > widthToHeight) {
      canvas.style.width = `${wHeight * widthToHeight}px`;
      canvas.style.height = 'auto';
    } else {
      canvas.style.height = `${wWidth / widthToHeight}px`;
      canvas.style.width = 'auto';
    }
  }
};
